__turbopack_context__.v({
  "tooltip": "ai-estimated-label-module-scss-module__f-y8VG__tooltip",
});
